export const reactionColorsAvailable = {
  like: "#6687c4",
  love: "#F3344E",
  haha: "#F7B026",
  wow: "#F7B026",
  sad: "#F7B026",
  angry: "#ED6B0F",
  unlike: undefined,
} as const;
